import http from 'plugins/axios';

export default {
    getAllCoin() {
        return http.get({
            url: '/admin/coin/all'
        });
    },
    getFocusPlateList(data) {
        return http.get({
            url: '/admin/focus/plate/list',
            data
        });
    },
    getPlateList(data) {
        return http.get({
            url: '/admin/plate/list',
            data
        });
    },
    listTradeRange(data) {
        return http.get({
            url: '/admin/tradeSet/list',
            data
        })
    },
    getTradePairList({ pair, area, page, size }) {
        return http.post({
            url: '/admin/tradePair/list',
            data: {
                pair,
                area,
                page,
                size
            },
            dataType: 'form'
        });
    },
    updateTradeStatus({ pair, status }) {
        return http.post({
            url: `/admin/tradePair/update/${pair}/trade/${status}`
        });
    },
    createTradePair(data) {
        return http.post({
            url: '/admin/tradePair/create',
            data,
            dataType: 'form'
        });
    },
    updateTradePair(data) {
        return http.post({
            url: '/admin/tradePair/update',
            data,
            dataType: 'form'
        });
    },
    removeTradePair(pair) {
        return http.post({
            url: '/admin/tradePair/remove',
            data: {
                pair
            },
            dataType: 'form'
        });
    },
    updateDefaultPrecision({ pair, precision }) {
        return http.post({
            url: '/admin/tradePair/update/defaultPrecision',
            data: {
                pair,
                precision
            },
            dataType: 'form'
        });
    },
    transaction(pair) {
        return http.post({
            url: '/admin/transaction',
            data: {
                pair
            },
            dataType: 'form'
        });
    },
    getTradeArea() {
        return http.get({
            url: '/admin/tradePair/area'
        });
    },
    updateSort({ pair, orderNo }) {
        return http.post({
            url: `/admin/tradePair/update/${pair}/sort`,
            data: {
                pair,
                orderNo
            },
            dataType: 'form'
        });
    },

    listVirtualTradeSet() {
        return http.get({
            url: '/admin/tradeSet/virtual',
        })
    },

    getAllPair() {
        return http.get({
            url: '/admin/tradePair/allDisplay'
        });
    },
    updateCoinBatch(data) {
        return http.post({
            url: '/admin/tradePair/update/batch',
            data,
            dataType: 'form'
        })
    }
};